import React, { useState, useEffect, useReducer, useMemo , useRef} from "react";
import ReactPaginate from "react-paginate";
import { Row, Col, Button, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { utils, writeFile } from 'xlsx';

import request from "services/request";
import CustomTable from "components/customTable";
import SortFilter from "components/customTable/sortFilter";
import DeleteModal from "views/commonViews/DeleteModal";
import useCurrencySymbol from "customHooks/useCurrencySymbol";
import { cloneDeep, calculateDynamicThresholds } from "common/utils.ts";
import { useLoading } from "contexts/LoadingContextManagement";

import MealModal from "./mealModel";
import { FaSearch } from 'react-icons/fa';
import RestaurantModel from "./restaurantModel"

import reducer, { ACTION_TYPES, initialState } from "./reducer";
import {
  CARBON_MEAL_CATEGORIES,
  DEFAULT_ERROR_MESSAGE,
  ITEMS_PER_PAGE,
} from "common/constants";
import { useUserData } from "contexts/AuthContextManagement";

import { getProvidersDummy } from "../../settings/utils";
import carbon_footprint_recipes  from "../../../data/carbon_footprint_recipes.json"

import Addicon from "assets/images/icon/ADD_WHITE.svg";
import Trashicon from "assets/images/icon/filter.svg";
import TelechargerIcon from "assets/images/telecharger.png";
import DashboardPage from "./index"
import storage from "services/storage";
import PENCIL_ICON from "assets/images/icon/pencil.svg";
import Mic from "assets/images/speaker1.png"
import Recipe from "assets/images/Recipe.png"
import { toast } from "react-toastify";
import { calculateIngredientCO2, calculateMealCO2PerServing } from "../../../utils/carbonCalculation";
import "./style.scss";

let isMountLoaded = false;

const getComputedWeight = (item) => {
  return ((item.carbon_footprint_ingredients?.reduce((acc, ing) => {
    let ingredient_unit = ing.CarbonFootprintIngredientMeal.ingredient_unit;
    return acc + (ingredient_unit === 'g' ? ing.CarbonFootprintIngredientMeal?.ingredient_quantity / 1000 : ing.CarbonFootprintIngredientMeal?.ingredient_quantity);
  }, 0)) / item?.servings) || 0;
};

const getComputedCO2 = (item) => {
  return calculateMealCO2PerServing(item.carbon_footprint_ingredients, item.servings);
};

const COMPUTED_SORT_FIELDS = {
  weight_in_kg: getComputedWeight,
  co2_impact_in_kg: getComputedCO2
};

function MyDashboardTable() {
  const tableRef = useRef(null);
  const { t, i18n } = useTranslation();
  const is_demo = JSON.parse(storage.getItem("is_demo"));
  const currentBrand = storage.getItem("brand");
  const { setLoading, setError } = useLoading();
  const [state, dispatch] = useReducer(reducer, initialState);
  const [modalShow2, setModalShow2] = useState(false);
  const [restaurantShow, setRestaurantShow] = useState(false);
  const [fd, setfd] = useState({ orderBy: "desc", search: "" });
  const [selectedMeal, setSelectedMeal] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [deleteModalShow, setDeleteModelShow] = useState(false);
  const [duplicateModalShow, setDuplicateModalShow] = useState(false);
  const [duplicateName, setDuplicateName] = useState("");
  const [duplicatingIds, setDuplicatingIds] = useState([]);
  const [duplicateEntries, setDuplicateEntries] = useState([]);
  const [isMyMeals, setIsMyMeals] = useState(true);
  const [report, setReport] = useState({});

  // We start with an empty list of items.
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [sleaveState, setSleaveState] = useState({
    index: -1,
    isOpen: true,
  });

  const { selectedRestaurantId, isRestaurantLoaded, hasRetaurants, selectedRestaurant, showMealModel, setShowMealModel } = useUserData();
  const [modalShow, setModalShow] = useState(showMealModel);

  useEffect(() => {
    setModalShow(showMealModel)
  }, [showMealModel])

  const tableColumns = [
    {
      caption: t("LocationCode"),
      className: "fw-bold dashboardHotelCode",
      style: { width: "200px", lineHeight: "3"},
      headerStyle: { width: "100px" },
      type: "customRender",
      render: (_, it) => (
        <span>{storage.getItem("location_code") || "HA595"}</span>
      ),
    },
     {
      caption: t("Recipe code"),
      dataField: "reference_number",
      sortable: false,
      className: "fw-bold dashboardHotelCode",
      style: { width: "100px", lineHeight: "3"},
      headerStyle: { width: "100px" },
      type: "text",
    },
    // {
    //   dataField: "name",
    //   caption: t("Dish"),
    //   className: "text-center",
    //   headerClassName: "text-center",
    //   type: "customRender",
    //   isExpand: true,
    //   render: (_, it, index) => {
    //     // console.log({it})
    //     const currentMonth = new Date().toLocaleString('default', { month: 'long' });

    //     // Check if any ingredient's seasonal_months matches the current month
    //     const showAlertIcon = it?.is_seasonal_alert !== false && 
    //       !it.carbon_footprint_ingredients?.some(ingredient => 
    //         ingredient.seasonal_months.includes(currentMonth)
    //       );
    //     console.log({showAlertIcon})
    //     const handleClick = () => {
    //       handleReportClick(index, it, showAlertIcon); 
    //     };
    //     return (
    //       <span onClick={handleClick} style={{ color: showAlertIcon ? 'red' : 'black' }}>
    //          {it?.name} {showAlertIcon && "⚠️"}
    //       </span>
    //     );
    //   }
    // },
    {
      dataField: "name",
      caption: t("Dish"),
      className: "text-center",
      headerClassName: "text-center",
      type: "customRender",
      isExpand: true,
      render: (_, it, index) => {
        const currentMonth = new Date().toLocaleString('en-US', { month: 'long' });

        const isCurrentMonthIncluded =  it?.carbon_footprint_ingredients?.map(ingredient => 
          ingredient.seasonal_months?.some((month => month?.toLowerCase() === currentMonth.toLowerCase()))) // Check if at least one ingredient includes the current month

        const showAlertIcon = it?.is_seasonal_alert || !isCurrentMonthIncluded
        const handleClick = () => {
          handleReportClick(index, it, showAlertIcon); 
        };
    
        return (
          <span onClick={handleClick} style={{ color: showAlertIcon ? 'red' : 'black', cursor: showAlertIcon ? 'pointer' : '' }}>
            {it?.name} {showAlertIcon && "⚠️"}
          </span>
        );
      }
    },
    
    // {
    //   className: "fw-bold",
    //   style: { width: "100px", display: "flex" },
    //   headerStyle: { width: "100px" },
    //   type: "customRender",
    //   render: (_, it) => (
    //     <img
    //       src={LabelImage}
    //       className="cursor-pointer"
    //       alt="..."
    //     />
    //   ),
    // },
    // {
    //   dataField: "restaurant.name",
    //   caption: t("Restaurant"),
    //   className: "text-center",
    //   headerClassName: "text-center",
    //   type: "customRender",
    //   render: (_, it) => {
    //     return <span>{selectedRestaurant?.name}</span>
    //   }
    // },
    {
      dataField: "weight_in_kg", 
      caption: t("Weight(kg)"),
      className: "text-center",
      headerClassName: "text-center",
      type: "customRender",
      isExpand: true,
      render: (_, it, index) => {
        // Calculate the total weight
        const totalWeight = ((it.carbon_footprint_ingredients?.reduce((acc, item) => {
          let ingredient_unit = item.CarbonFootprintIngredientMeal.ingredient_unit;
          return acc + (ingredient_unit === 'g' ? item.CarbonFootprintIngredientMeal?.ingredient_quantity / 1000 : item.CarbonFootprintIngredientMeal?.ingredient_quantity);
        }, 0)) / it?.servings)?.toFixed(3);
        
        // Set the value for weight greater then 2kg
        const isShowWeightIcon = it?.is_weight_alert !== false && totalWeight > 1.5;
        const handleClick = () => {
          handleReportClick(index, it, isShowWeightIcon);
        };
        return (
          <span
            style={totalWeight > 1.5 ? { color: 'red', cursor: 'pointer' } : {}}
            onClick={handleClick}
          >
            {totalWeight} {isShowWeightIcon && '⚠️'}
          </span>
        );
      }
    },    
    {
      dataField: "category",
      caption: t("Categories"),
      className: "text-center",
      headerClassName: "text-center",
      type: "customRender",
      render: (_, it) => {
        const category = (CARBON_MEAL_CATEGORIES.find((item) => {
          if(item.id === it.category || item.id === it?.type) {
            return item
          }
        }))?.label
        return <span>{t(category)}</span>
      }
    },
    {
      // dataField: "category",
      caption: t("Label"),
      className: "text-center",
      headerClassName: "text-center",
      type: "customRender",
      render: (_, it) => {
        const imageUrl = `${process.env.PUBLIC_URL}/images/brands/${currentBrand}-${getColorBasedOnCarbonEmission((getSum(it.carbon_footprint_ingredients)?.toFixed(2)/it?.servings || 0) * 1000, it.type, it.service_type, it.weight_in_kg, it.servings).offset}.png`;
        return(
        <img
          src={imageUrl}
          className="cursor-pointer"
          alt="..."
          style={{ width: "40px", height: "40px", objectFit: "contain" }}
        />
      )},
    },
    {
      dataField: "co2_impact_in_kg",
      caption: t("Carbon impact (Kg CO2eq)"),
      className: "text-center",
      headerStyle: { whiteSpace: "normal"},
      headerClassName: "text-center",
      type: "customRender",
      render: (_, it) => {
        return <span>{calculateMealCO2PerServing(it.carbon_footprint_ingredients, it.servings)?.toFixed(4)}</span>
      }
    },
    {
      dataField: "menu",
      sortable: false,
      caption: t("Menu"),
      className: "text-center",
      style: { width: "30px" },
      headerClassName: "text-center",
      type: "customRender",
      render: (_, it) => (
        <Form.Check className="menu-checkbox" aria-label="option 1"/>
      ),
    },
    {
      dataField: "action",
      // caption: "Action",
      className: "text-center",
      headerClassName: "text-center",
      type: "customRender",
      render: (_, it) => (
        <img
          src={PENCIL_ICON}
          className="cursor-pointer"
          alt="..."
          onClick={showRow(it)}
        />
      ),
    },
  ];

  function getSum(ingredients) {
    return (ingredients || []).reduce(
      (acc, ingredient) => acc + calculateIngredientCO2(ingredient),
      0
    );
  };
  
  function getColorBasedOnCarbonEmission(carbonEmission, mealType, serviceType = null, portionWeightInKg = null, servings = 1) {
    let carbonValue = parseFloat(carbonEmission)
    
    if (!carbonEmission || !mealType) {
      return {color: "#65a700", offset: 0}
    }

    const portionWeight = portionWeightInKg ? (portionWeightInKg * 1000) / servings : null;
    
    const thresholds = portionWeight 
      ? calculateDynamicThresholds(mealType, serviceType, portionWeight)
      : null;

    if (thresholds) {
      if (carbonValue <= thresholds.excellent) {
        return {color: "#65a700", offset: 0};
      }
      if (carbonValue > thresholds.excellent && carbonValue <= thresholds.good) {
        return {color: "#a4f500", offset: 25};
      }
      if (carbonValue > thresholds.good && carbonValue <= thresholds.average) {
        return {color: "#ffc300", offset: 50};
      }
      if (carbonValue > thresholds.average && carbonValue <= thresholds.poor) {
        return {color: "#ff1d00", offset: 75};
      }
      if (carbonValue > thresholds.poor) {
        return {color: "#890500", offset: 100};
      }
    }

    if (((mealType === 'starters' || mealType === 'desserts') && carbonValue <= 200) || (mealType === 'mainDishes' && carbonValue <= 500)) {
      return {color: "#65a700", offset: 0};
    }
    if (((mealType === 'starters' || mealType === 'desserts') && (carbonValue > 200 && carbonValue <= 400)) || (mealType === 'mainDishes' && (carbonValue > 500 && carbonValue <= 1000))) {
      return {color: "#a4f500", offset: 25};
    }
    if (((mealType === 'starters' || mealType === 'desserts') && (carbonValue > 400 && carbonValue <= 600)) || (mealType === 'mainDishes' && (carbonValue > 1000 && carbonValue <= 1500))) {
      return {color: "#ffc300", offset: 50};
    }
    if (((mealType === 'starters' || mealType === 'desserts') && (carbonValue > 600 && carbonValue <= 800)) || (mealType === 'mainDishes' && (carbonValue > 1500 && carbonValue <= 2000))) {
      return {color: "#ff1d00", offset: 75};
    }
    if (((mealType === 'starters' || mealType === 'desserts') && carbonValue > 800) || (mealType === 'mainDishes' && carbonValue > 2000)) {
      return {color: "#890500", offset: 100};
    }
    
    return {color: "#65a700", offset: 0}
  };

  const handleReportClick = (index, meal, isShowSeasonalIcon) => {
    setReport({meal, isShowSeasonalIcon});
  };

  const getDownloadMeals = async () => {
    try {
      const result = await getMeals(1, true);
      setCurrentItems(() => result.cf_meals);
      setPageCount(result.total_pages);
    } catch (error) {
      setError(DEFAULT_ERROR_MESSAGE);
    }
  };
const onDownload = async () => {
  // Convert table to sheet
  await getDownloadMeals()
  const ws = utils.table_to_sheet(tableRef.current);

  // Add static data
  const staticData = [
    [`Restaurant name: ${selectedRestaurant.name}`], // A1
    [], // A2
    [], // A3 (empty row)
  ];

  // Combine static data and table data
  const tableData = utils.sheet_to_json(ws, { header: 1 }); // Convert existing sheet data to array
  const combinedData = [...staticData, ...tableData]; // Combine static and table data

  // Create a new sheet with combined data
  const newWs = utils.aoa_to_sheet(combinedData);

  // Adjust the file name
  const fileName = i18n.language === 'fr' 
    ? `${selectedRestaurant.name}_Extraction plats_${new Date().toLocaleDateString()}`
    : `${selectedRestaurant.name}_Meals extraction_${new Date().toLocaleDateString()}`;

  // Create a new workbook and append the sheet
  const wb = utils.book_new();
  utils.book_append_sheet(wb, newWs, 'Sheet1');

  // Download the Excel file
  writeFile(wb, `${fileName}.xlsx`);
};

  // Invoke when user click to request another page.
  const handlePageClick = async (event) => {
    try {
      const result = await getMeals(event.selected + 1);
      setCurrentItems(() => result.cf_meals);
      setPageCount(result.total_pages);
      setCurrentPage(event.selected);
    } catch (error) {
      setError(DEFAULT_ERROR_MESSAGE);
    }
  };

  useEffect(() => {
    if(selectedRestaurantId) {
      getInitialData()
    }
    if (isRestaurantLoaded && !hasRetaurants && is_demo) {
      getMeals()
      getAllergens()
      getProviders()
      return
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRestaurantId, isRestaurantLoaded, hasRetaurants]);

  useEffect(() => {
    if (!isMountLoaded) {
      return;
    }
      fetchAndSetMeals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fd.search, fd.sortby, fd.orderBy]);

  const fetchAndSetMeals = async () => {
    try {
      const result = await getMeals(currentPage+1);
      dispatch({ type: ACTION_TYPES.MULTI, meals: result.cf_meals });
      setCurrentItems(() => result.cf_meals);
      setPageCount(result.total_pages);
      setCurrentPage(result.page - 1);
      setLoading(false);
    } catch (error) {
      setError(DEFAULT_ERROR_MESSAGE);
    }
  };
// carbon_footprint_recipes
  const getMeals = (page = 1, is_download = false) => {
    if (isRestaurantLoaded && !hasRetaurants) {
      setCurrentItems(() => carbon_footprint_recipes.cf_meals);
      setPageCount(1);
      setCurrentPage(0);
      return 
    }
    let payload = {
      restaurant_id: selectedRestaurantId,
      limit: ITEMS_PER_PAGE,
      page: fd.search ? 1 : page,
      order_by: fd.orderBy.toUpperCase(),
      ...(fd.sortby && { sort_by: fd.sortby }),
      ...(fd.search && { search: fd.search }),
      ...(is_download && { is_download }),
    };
    return request.get(`carbon-footprint-meals`, payload);
  };

  const getAllergens = () => request.get("allergens");

  const getProviders = () => {
    if (isRestaurantLoaded && !hasRetaurants) {
      return getProvidersDummy();
    }
    return request.get(`providers?restaurant_id=${selectedRestaurantId}`);
  };

  const getInitialData = async () => {
    setLoading(true);
    try {
      const [meals, allergens, providers] = await Promise.all([
        getMeals(),
        getAllergens(),
        getProviders(),
      ]);
      dispatch({
        type: ACTION_TYPES.MULTI,
        payload: {
          meals: meals.cf_meals,
          allergens: allergens.allergens,
          providers: providers.providers,
        },
      });
      setCurrentItems(() => meals.cf_meals);
      setPageCount(meals.total_pages);
      isMountLoaded = true;
      setLoading(false);
    } catch (error) {
      setError(DEFAULT_ERROR_MESSAGE);
    }
  };

  const showRow = (row) => () => {
    setSelectedMeal({ ...row, selling_price_per_person: row.price_per_person });
    setModalShow(true);
    setShowMealModel(true);
  };

  const onRowAdded = () => {
    fetchAndSetMeals();
    setSelectedMeal(null);
  };

  const selectChange =
    (it) =>
    ({ target: { checked } }) => {
      const newSelectedRows = cloneDeep(selectedRows);
      if (checked) {
        setSelectedRows(() => [...newSelectedRows, it.id]);
      } else {
        setSelectedRows(() => newSelectedRows.filter((p) => p !== it.id));
      }
    };

  const selectAllRows = ({ target: { checked } }) => {
    setSelectedRows(() => (checked ? [...currentItems.map((f) => f.id)] : []));
  };

  const deleteRows = async (mealId) => {
    try {
      const idsToDelete = mealId ? [mealId] : selectedRows; 
      const result = await request.delete(`/carbon-footprint-meals`, { cf_meal_ids: idsToDelete });
      
      if (result.status === 200) {
        if (mealId) {
          setCurrentItems((currentItems) =>
            currentItems.filter((item) => item.id !== mealId)
          );
        } else {
          setSelectedRows([]);
          setCurrentItems((currentItems) =>
            currentItems.filter((item) => !selectedRows.includes(item.id))
          );
        }
      }
    } catch (error) {
      console.log(error);
      setError(DEFAULT_ERROR_MESSAGE);
    }
  };

  const handleDuplicate = async () => {
    if (selectedRows.length === 1) {
      setDuplicateName("");
      setDuplicatingIds(selectedRows);
      setDuplicateEntries([]);
    } else {
      const entries = selectedRows.map(id => {
        const meal = currentItems.find(item => item.id === id);
        return { id, originalName: meal?.name || "", newName: "" };
      });
      setDuplicateEntries(entries);
      setDuplicatingIds(selectedRows);
      setDuplicateName("");
    }
    setDuplicateModalShow(true);
  };

  const handleDuplicateConfirm = async () => {
    setDuplicateModalShow(false);
    try {
      setLoading(true);
      let entries;
      if (duplicateEntries.length > 0) {
        entries = duplicateEntries.map(entry => ({
          cf_meal_id: entry.id,
          ...(entry.newName.trim() && { name: entry.newName.trim() }),
        }));
      } else {
        entries = duplicatingIds.map(id => ({
          cf_meal_id: id,
          ...(duplicateName.trim() && { name: duplicateName.trim() }),
        }));
      }
      const result = await request.post("/carbon-footprint-meals/duplicate-bulk", { entries });
      if ([200, 201].includes(result.status)) {
        setSelectedRows([]);
        await fetchAndSetMeals();
      } else {
        setError(DEFAULT_ERROR_MESSAGE);
      }
    } catch (error) {
      setError(DEFAULT_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  };

  const updateDuplicateEntryName = (id, newName) => {
    setDuplicateEntries(prev =>
      prev.map(entry => (entry.id === id ? { ...entry, newName } : entry))
    );
  };

  const onModalHide = () => {
    setSelectedMeal(null);
    setModalShow(false);
    setShowMealModel(false);
  };

  const processedCurrentItems = useMemo(() => {
    const newCurrentItems = [...currentItems];
    if(sleaveState.index !== -1) {
      newCurrentItems[sleaveState.index] = {...newCurrentItems[sleaveState.index], prediction: { isOpen: sleaveState.isOpen }};
    }

    const computeFn = COMPUTED_SORT_FIELDS[fd.sortby];
    if (computeFn) {
      newCurrentItems.sort((a, b) => {
        const valA = computeFn(a);
        const valB = computeFn(b);
        return fd.orderBy === 'asc' ? valA - valB : valB - valA;
      });
    }

    return newCurrentItems;
  }, [currentItems, sleaveState, fd.sortby, fd.orderBy])

  const updateSeasonalAlert = async(id, name, servings, is_seasonal_alert, restaurant_id, ingredients) => {
    try {
      let payload = {
        name: name,
        servings: servings,
        is_seasonal_alert: is_seasonal_alert,
        carbon_footprint_ingredients: ingredients,
        restaurant_id: restaurant_id,
      };
      const response = await request.patch(`/carbon-footprint-meals/${id}`, payload);
      if (response.status === 200) {
        getInitialData();
      }
      return response; 
    } catch (error) {
      console.log(error);
    }
  };

  const updateWeightAlert = async(id, name, servings, is_weight_alert, restaurant_id, ingredients) => {
    try {
      let payload = {
        name: name,
        servings: servings,
        is_weight_alert: is_weight_alert,
        carbon_footprint_ingredients: ingredients,
        restaurant_id: restaurant_id,
      };
      const response = await request.patch(`/carbon-footprint-meals/${id}`, payload);
      if (response.status === 200) {
         getInitialData();
      }
      return response; 
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
    {
       modalShow2 ? <DashboardPage/> :
      <div className="my-ingredients">
        <MealModal
          show={modalShow}
          onHide={onModalHide}
          onRowAdded={onRowAdded}
          setSelectedMeal={setSelectedMeal}
          state={{ ...state, ...(selectedMeal && { selectedMeal }) }}
        />

        <RestaurantModel
          show={restaurantShow}
          onHide={setRestaurantShow}
          onRowAdded={onRowAdded}
        />

        <DeleteModal
          show={deleteModalShow}
          onHide={() => setDeleteModelShow(false)}
          onPositiveClicked={() => {
            setDeleteModelShow(false);
            deleteRows();
          }}
          modalData={{
            title: t("Delete meals"),
            description: t(
              "Are you sure you want to delete meals ? You cannot undo this action."
            ),
            positiveBtnTitle: t("Yes, delete meals"),
          }}
        />

        <Modal show={duplicateModalShow} onHide={() => setDuplicateModalShow(false)} centered size={duplicateEntries.length > 0 ? "lg" : undefined}>
          <Modal.Header closeButton>
            <Modal.Title>{t("DuplicateRecipe")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {duplicateEntries.length > 0 ? (
              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <Row className="mb-2" style={{ fontWeight: "600", fontSize: "13px", color: "#8b8f94" }}>
                  <Col xs={5}>{t("MealName")}</Col>
                  <Col xs={2} className="text-center"></Col>
                  <Col xs={5}>{t("NewRecipeName")}</Col>
                </Row>
                {duplicateEntries.map((entry) => (
                  <Row key={entry.id} className="align-items-center">
                    <Col xs={5}>
                      <Form.Control
                        type="text"
                        value={entry.originalName}
                        disabled
                        style={{ backgroundColor: "#f3f4fb" }}
                      />
                    </Col>
                    <Col xs={2} className="text-center" style={{ fontSize: "20px", color: "#6353EA" }}>
                      →
                    </Col>
                    <Col xs={5}>
                      <Form.Control
                        type="text"
                        value={entry.newName}
                        placeholder={t("Give a name to your recipe")}
                        onChange={e => updateDuplicateEntryName(entry.id, e.target.value)}
                      />
                    </Col>
                  </Row>
                ))}
              </div>
            ) : (
              <Form.Group>
                <Form.Label>{t("NewRecipeName")}</Form.Label>
                <Form.Control
                  type="text"
                  value={duplicateName}
                  placeholder={t("Give a name to your recipe")}
                  onChange={e => setDuplicateName(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && duplicateName.trim() && handleDuplicateConfirm()}
                  autoFocus
                />
              </Form.Group>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={() => setDuplicateModalShow(false)}>
              {t("Cancel")}
            </Button>
            <Button
              variant="primary"
              onClick={handleDuplicateConfirm}
              disabled={duplicateEntries.length > 0
                ? false
                : !duplicateName.trim()
              }
            >
              {t("Duplicate")}
            </Button>
          </Modal.Footer>
        </Modal>

        <Row>
          <h2>{t("WelcomeDashboard")}</h2>
          <span className="add-restaurants-input-title">
            {t("AddOrModifyInformationOfDishes")}
          </span>      
        </Row>
        <Row style={{marginLeft:"0px"}}>
          <div className="d-flex row dashboard-table" style={{marginTop: "50px", gap: "26px"}}>
            {isMyMeals && 
            <Col xs="auto">
              <Button
                variant="primary add-btn-container"
                onClick={() => setModalShow(true)}
              >
                <img src={Addicon} className="add-btn-icon" alt="..." />
                {t("AddARecipe")}
              </Button>
            </Col>
            }
            {isMyMeals && <Col xs="auto">
              <Button
                variant="primary add-btn-container"
                onClick={() => setRestaurantShow(true)}
              >
                <img src={Addicon} className="add-btn-icon" alt="..." />
                {t("AddARestaurant")}
              </Button>
            </Col>}


            {/* <Col xs="auto">
              <img src={Mic} style ={{ background:"#6353EA", cursor: "pointer", objectFit: "contain", borderRadius:"5px", marginRight:"15px", borderRadius: "5px", height: "39px", width:"42px"}}/>
            </Col> */}
            

            <Col className="sort-container d-flex justify-content-end gap-3">
              {isMyMeals && (
                <Button
                  variant="primary"
                  onClick={() => {
                    if (selectedRows.length === 0) {
                      toast.info(t("Please select at least one recipe to duplicate"));
                      return;
                    }
                    handleDuplicate();
                  }}
                  style={{
                    borderRadius: "5px",
                    height: "38px",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  {t("Duplicate")}
                </Button>
              )}
              {Boolean(selectedRows.length) && (
                <img
                  src={Trashicon}
                  onClick={() => setDeleteModelShow(true)}
                  alt="..."
                />
              )}
              
              <div className="searchContainer">
              {!fd.search && <FaSearch className="searchIcon" />}  
              <input
                type="search"
                className="search-input"
                placeholder={t("Search")}
                onChange={(e) => setfd({ ...fd, search: e.target.value })}
              />
              </div>
              <button
                className="btn btn-white btn-icon"
                style={{ height: "38px", width: "41px", textAlign: "center", padding: "0px", display: "flex", justifyContent: "center" }}
                onClick={onDownload}
              >
                <img src={TelechargerIcon} alt="" className="m-0" style={{height:"24px"}}/>
              </button>

              <SortFilter
                cols={tableColumns}
                fd={fd}
                setfd={setfd}
                rootClassName="sort-filter"
              />
            </Col>
          </div>
        </Row>
        <div className="mt-3 table-container">
          <CustomTable
            ref={tableRef}
            columns={tableColumns}
            data={processedCurrentItems}
            editRow={showRow}
            selectChange={selectChange}
            selectedProducts={selectedRows}
            selectAllProducts={selectAllRows}
            onReport={report}
            currentTable="dashboard"
            updateSeasonalAlert={updateSeasonalAlert}
            updateWeightAlert={updateWeightAlert}
          />

          <Row>
            <Col lg={12}>
              <div className="d-flex justify-content-end mt-2"> 
                <ReactPaginate
                  nextLabel={`${t("Next")}   >`}
                  onPageChange={handlePageClick}
                  forcePage={currentPage}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={2}
                  pageCount={pageCount}
                  previousLabel={`<   ${t("Back")}`}
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName="active"
                  renderOnZeroPageCount={null}
                  previousAriaLabel={t("Previous page")}
                  nextAriaLabel={t("Next page")}
                  ariaLabelBuilder={(page) => `${t("Page")} ${page}`}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    }
    </>
  );
}

export default MyDashboardTable;
